import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { AlertSubscriptionAction } from './alertSubscription.action';
import { initialAlertsDataState } from './alertSubscription.constant';

export const alertSubscriptionReducer = reducerWithInitialState(initialAlertsDataState)
  .case(AlertSubscriptionAction.loadSubscriptions.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(AlertSubscriptionAction.loadSubscriptions.done, (state, { result }) => ({
    ...state,
    ...result,
    networkStatus: NetworkStatus.Done,
  }))
  .case(AlertSubscriptionAction.loadSubscriptions.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(AlertSubscriptionAction.updateSubscription.started, (state, payload) => {
    const processingCells = new Set(state.processingCells);
    processingCells.add(payload.type);

    return {
      ...state,
      subscriptions: state.subscriptions.map(sub =>
        sub.type === payload.type ? { ...sub, enabled: payload.enabled } : sub,
      ),
      processingCells,
    };
  })
  .case(AlertSubscriptionAction.updateSubscription.done, (state, { params }) => {
    const processingCells = new Set(state.processingCells);
    processingCells.delete(params.type);

    return {
      ...state,
      processingCells,
    };
  })
  .case(AlertSubscriptionAction.updateSubscription.failed, (state, { params }) => {
    const processingCells = new Set(state.processingCells);
    processingCells.delete(params.type);

    return {
      ...state,
      subscriptions: state.subscriptions.map(sub =>
        sub.type === params.type ? { ...sub, enabled: !params.enabled } : sub,
      ),
      processingCells,
    };
  })
  .case(AlertSubscriptionAction.addEmailToSubscription.started, (state, payload) => {
    const { email, type, enabled } = payload;
    const processingCells = new Set(state.processingCells);
    processingCells.add(`${email}_${type}`);

    return {
      ...state,
      subscriptions: state.subscriptions.map(sub => {
        if (sub.type === type) {
          const recipients = enabled
            ? [...sub.recipients.filter(r => r !== email), email]
            : sub.recipients.filter(r => r !== email);
          return { ...sub, recipients };
        }
        return sub;
      }),
      processingCells,
    };
  })
  .case(AlertSubscriptionAction.addEmailToSubscription.done, (state, { params }) => {
    const processingCells = new Set(state.processingCells);
    processingCells.delete(`${params.email}_${params.type}`);

    return {
      ...state,
      processingCells,
    };
  })
  .case(AlertSubscriptionAction.addEmailToSubscription.failed, (state, { params }) => {
    const { email, type, enabled } = params;
    const processingCells = new Set(state.processingCells);
    processingCells.delete(`${email}_${type}`);

    return {
      ...state,
      subscriptions: state.subscriptions.map(sub => {
        if (sub.type === type) {
          const recipients = enabled
            ? sub.recipients.filter(r => r !== email)
            : [...sub.recipients.filter(r => r !== email), email];
          return { ...sub, recipients };
        }
        return sub;
      }),
      processingCells,
    };
  })
  .cases([
    AlertSubscriptionAction.addEmail.started, AlertSubscriptionAction.deleteEmail.started,
  ], (state) => ({
    ...state,
    processing: true,
  }))
  .cases([
    AlertSubscriptionAction.addEmail.done, AlertSubscriptionAction.deleteEmail.done,
    AlertSubscriptionAction.addEmail.failed, AlertSubscriptionAction.deleteEmail.failed,
  ], (state) => ({
    ...state,
    processing: false,
  }))
  .case(AlertSubscriptionAction.destroy, () => initialAlertsDataState);
